import { type LabelProps, Label } from '@launchpad-ui/components';
import { clsx } from 'clsx';

import styles from './RequiredLabel.module.css';

export interface RequiredLabelProps extends LabelProps {
  isRequired?: boolean;
}

export function RequiredLabel({ children, isRequired, className, ...rest }: RequiredLabelProps) {
  return (
    <Label className={clsx(styles.label, className)} {...rest}>
      {children} {isRequired && <span className={styles.required}>*</span>}
    </Label>
  );
}
